
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DeadlineDialog from '../ordermanage/detail/detail/deadline.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import util from '@/utils/busi/util'
import { checkPermission } from '@/utils/permission'
import dayjs from 'dayjs'
import { getEntranceApplyList, getEntranceApplyListCount } from '@/api/ordercenter'
import { LocalStorage } from '@/utils/storage'
@Component({
  name: 'entrance-manage',
  components: {
    SimpleTable,
    DeadlineDialog,
    DictSelect
  }
})
export default class EntranceManage extends Vue {
  private checkPermission: any = checkPermission

  private pickerOptions = {
    shortcuts: [
      {
        text: '上一周',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '最近一个月',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          picker.$emit('pick', [start, end])
        }
      },
      {
        text: '最近三个月',
        onClick (picker: { $emit: (arg0: string, arg1: Date[]) => void }) {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
          picker.$emit('pick', [start, end])
        }
      }
    ],
    disabledDate: !0,
    firstDayOfWeek: 7,
    cellClassName: () => 'custClass',
    onPick: null
  }

  get exportName () {
    const day = dayjs(new Date()).format('YYYYMMDD')
    return `入场申请结果-${day}`
  }

  private exportParam () {
    const temp = { ...this.form }
    if (temp.createTime) {
      temp.createStartTime = temp.createTime[0]
      temp.createEndTime = temp.createTime[1]
    }
    delete temp.createTime
    if (temp.confirmTime) {
      temp.confirmStartTime = temp.confirmTime[0]
      temp.confirmEndTime = temp.confirmTime[1]
    }
    delete temp.confirmTime
    return util.trimForm({ ...temp }, this.columns)
  }

  private exportable = {
    exportable: checkPermission(['applicantExport']),
    src: '/lb/applicant/export',
    data: this.exportParam
  }

  private form: any = {
    createTime: [new Date((new Date()).getFullYear().valueOf() + '/' + '01' + '/' + '01 00:00').getTime(), new Date(new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate() + ' 23:59:59').getTime()],
    confirmTime: '',
    applicantName: '',
    phone: '',
    agentName: '',
    applicantSchoolName: '',
    applicantType: -1
  }

  private loading = !1

  private tableData = {
    list: [],
    totalCount: 1
  }

  private columns = [
    {
      prop: 'applicantName',
      label: '姓名'
    },
    {
      prop: 'stuSexName',
      label: '性别',
      disabled: !0
    },
    {
      prop: 'phone',
      label: '手机号'
    },
    {
      prop: 'applicantSchoolName',
      label: '场次信息',
      default: ['applicantSchoolName']
    },
    {
      prop: 'gradSchool',
      label: '毕业院校',
      disabled: !0
    },
    {
      prop: 'notes',
      label: '备注',
      disabled: !0
    },
    {
      prop: 'agentName',
      label: '代理人'
    },
    {
      prop: 'createTime',
      label: '申请时间',
      default: ['createStartTime', 'createEndTime'],
      format: 'date'
    },
    {
      prop: 'applicantState',
      label: '入场情况',
      custom: !0,
      disabled: !0
    },
    {
      prop: 'confirmTime',
      label: '入场时间',
      default: ['confirmStartTime', 'confirmEndTime'],
      format: 'date'
    },
    {
      prop: 'confirmName',
      label: '入场确认人',
      disabled: !0
    }
  ]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private async onQuery (pagination: any = null) {
    this.loading = !0
    const temp = { ...this.form }
    if (temp.createTime) {
      temp.createStartTime = temp.createTime[0]
      temp.createEndTime = temp.createTime[1]
    }
    delete temp.createTime
    if (temp.confirmTime) {
      temp.confirmStartTime = temp.confirmTime[0]
      temp.confirmEndTime = temp.confirmTime[1]
    }
    delete temp.confirmTime
    const form = util.trimForm({ ...temp }, this.columns)
    !pagination && (this.pagination.currentPage = 1)
    await getEntranceApplyList({
      ...form,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      await getEntranceApplyListCount({
        ...form
      }).then((resCount: any) => {
        this.loading = !1
        const userType = LocalStorage.getObj('user_info_key').userType
        console.log('onQuery-userType:', userType)
        // if (userType === 3) {
        //   this.tableData.list = res.object.list.map((v: any) => {
        //     v.phone && (v.phone = (v.phone.substring(0, 5) + '******'))
        //     return v
        //   })
        // } else {
        //   this.tableData.list = res.object.list
        // }
        this.tableData.list = res.object.list
        this.tableData.totalCount = resCount.object.totalCount
      }).catch((err: any) => {
        console.log('err', err)
        this.loading = !1
      })
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
      createTime: [new Date((new Date()).getFullYear().valueOf() + '/' + '01' + '/' + '01 00:00').getTime(), new Date(new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate() + ' 23:59:59').getTime()],
      confirmTime: '',
      applicantName: '',
      phone: '',
      agentName: '',
      applicantSchoolName: '',
      applicantType: -1
    }
    this.onQuery()
  }

  private rowDbClick (row: any) {
    console.log('rowDbClick:', row)
  }

  mounted () {
    if (checkPermission(['applicantList'])) {
      this.onQuery()
    }
  }
}
